import { StructureSetRepository } from './repository/StructureSetRepository';
import { RegistrationStore } from './stores/RegistrationStore';
import { ContourUndoService } from './undo/ContourUndoService';
import { RegistrationUndoService } from './undo/RegistrationUndoService';

class ServiceContainer {
    private services = new Map<string, unknown>();
    private singletons = new Map<string, unknown>();

    register<T>(name: string, factory: () => T): void {
        this.services.set(name, factory);
    }

    registerSingleton<T>(name: string, factory: () => T): void {
        this.services.set(name, factory);
        this.singletons.set(name, null);
    }

    get<T>(name: string): T {
        if (this.singletons.has(name)) {
            const existing = this.singletons.get(name);
            if (existing !== null && existing !== undefined) {
                return existing as T;
            }
        }

        const factory = this.services.get(name);
        if (!factory) {
            throw new Error(`Service '${name}' not found in container`);
        }

        const instance = (factory as () => T)();

        if (this.singletons.has(name)) {
            this.singletons.set(name, instance);
        }

        return instance;
    }

    has(name: string): boolean {
        return this.services.has(name);
    }

    clear(): void {
        this.services.clear();
        this.singletons.clear();
    }
}

export const container = new ServiceContainer();

container.registerSingleton(
    'StructureSetRepository',
    () => new StructureSetRepository()
);
export const getStructureSetRepository = (): StructureSetRepository =>
    container.get<StructureSetRepository>('StructureSetRepository');

container.registerSingleton(
    'ContourUndoService',
    () => new ContourUndoService()
);
export const getContourUndoService = (): ContourUndoService =>
    container.get<ContourUndoService>('ContourUndoService');

container.registerSingleton(
    'RegistrationUndoService',
    () => new RegistrationUndoService()
);
export const getRegistrationUndoService = (): RegistrationUndoService =>
    container.get<RegistrationUndoService>('RegistrationUndoService');

container.registerSingleton('RegistrationStore', () => new RegistrationStore());
export const getRegistrationStore = (): RegistrationStore =>
    container.get<RegistrationStore>('RegistrationStore');

export { ServiceContainer };
